import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { translate } from '@fiverr-private/i18n-react';
import { Typography } from '@fiverr-private/typography';
import { TruncatedText } from '../TruncatedText';
import { Preference } from '../Preference';
import { Gql } from '../../../types';

const T_PREFIX = 'dynamic_matching.freelancer_preferences.fields.location';
const getCountryName = (code: string) => translate(`countries.${code}`);
const getRegionName = (region: string) => translate(`${T_PREFIX}.regions.${region}`);

export const LocationPreference = ({
  countries,
  regions,
  matchIndicator,
  sellerName,
  sellerLocation,
  isSeller,
}: {
  countries: Gql.DmBriefCountryCode[];
  regions: string[];
  matchIndicator?: Gql.Maybe<Gql.DmBriefMatchIndicator>;
  sellerName?: string;
  sellerLocation?: string | null;
  isSeller: boolean;
}) => {
  const locations = [
    ...regions.map((region) => getRegionName(region.toLocaleLowerCase())),
    ...countries.filter((country) => country !== Gql.DmBriefCountryCode.Zz).map(getCountryName),
  ];
  const tooltipContent = !isSeller ? (
    <TooltipText sellerName={sellerName} sellerLocation={sellerLocation} />
  ) : undefined;

  return (
    <Preference name="location" matchIndicator={matchIndicator} tooltipContent={tooltipContent}>
      <Stack width="100%" wrap="wrap" flexShrink={1} direction={{ default: 'column', sm: 'row' }} gap={'1'}>
        <TruncatedText text={locations.join(', ')} />
      </Stack>
    </Preference>
  );
};

const TooltipText = ({ sellerName, sellerLocation }: { sellerName?: string; sellerLocation?: string | null }) => (
  <Stack direction="row" gap="0">
    <Typography>
      {sellerName}
      {translate(`${T_PREFIX}.tooltip`)} {getCountryName(sellerLocation || '')}
    </Typography>
  </Stack>
);
